/**
 * App-init bootstrap for fall-sale flags (Gatsby onClientEntry).
 * Starts ConfigCat early (no Segment identity) and exposes a shared promise
 * so FallSaleProvider can show the banner as soon as flags resolve.
 */

import { featureFlags } from "./instance"
import { FALL_SALE_FLAG_DEFAULTS } from "./keys"

/** @type {{ values: Record<string, boolean|number|string> }|null} */
let snapshot = null

/** @type {Promise<{ values: Record<string, boolean|number|string> }>|null} */
let preloadPromise = null

export function getFallSaleSnapshot() {
  return snapshot
}

/**
 * Start / reuse ConfigCat preload for fall-sale keys (no Segment identity).
 * @returns {Promise<{ values: Record<string, boolean|number|string> }>}
 */
export function preloadFallSaleFlags() {
  if (preloadPromise) return preloadPromise

  preloadPromise = (async () => {
    const defaults = { ...FALL_SALE_FLAG_DEFAULTS }

    try {
      if (!featureFlags.isAvailable()) {
        snapshot = { values: defaults }
        return snapshot
      }

      const ready = await featureFlags.initialize()
      if (!ready) {
        snapshot = { values: defaults }
        return snapshot
      }

      const entries = Object.keys(FALL_SALE_FLAG_DEFAULTS)
      const values = Object.fromEntries(
        await Promise.all(
          entries.map(async (key) => [
            key,
            await featureFlags.getValue(key, FALL_SALE_FLAG_DEFAULTS[key], {}),
          ])
        )
      )

      snapshot = { values }
      return snapshot
    } catch {
      snapshot = { values: defaults }
      return snapshot
    }
  })()

  return preloadPromise
}

export function whenFallSaleFlagsReady() {
  return preloadFallSaleFlags()
}
